/**
 * Determines if the clients browser supports
 * local storage or not.
 * @returns {boolean} true if does else false
 */
function isLocalStorageAvailable() {
    var test = 'test'
    try {
        window.localStorage.setItem(test, test)
        window.localStorage.removeItem(test)
        return true
    } catch {
        return false
    }
}

export { isLocalStorageAvailable }
